import { ref, onMounted } from 'vue'

export const useAOS = () => {
  const isClient = ref(false)
  
  onMounted(() => {
    isClient.value = true
  })
  
  // 辅助函数：获取 AOS 属性
  const getAOSAttrs = (animation: string, delay?: string | number) => {
    // 使用 process.server 来判断是否在服务器端
    if (process.server) return {}
    
    return {
      'data-aos': animation,
      ...(delay && { 'data-aos-delay': String(delay) })
    }
  }
  
  return {
    isClient,
    getAOSAttrs
  }
}
